<p-dialog
  [(visible)]="visible"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '35rem', height: 'auto' }"
  (visibleChange)="visibleChange.emit($event)">

  <!-- HEADER CUSTOMIZADO COM WAVE -->
  <div class="dialog-wave-header dialog-wave-header--info">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-print" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ chaveTitulo | translate }}</h2>
        <p>{{ chaveSubtitulo | translate }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <!-- CORPO DO DIALOG -->
  <div class="dialog-wave-body">
    <div class="field">
      <label for="codigoImpressoraDialog">{{ 'Codigo_da_Impressora' | translate }}</label>
      <input
        id="codigoImpressoraDialog"
        type="number"
        pInputText
        [(ngModel)]="codigoImpressora"
        placeholder="{{ 'Digite_o_codigo_da_Impressora' | translate }}"
        class="w-full" />
    </div>
    <div class="field">
      <label for="nomeImpressoraDialog">{{ 'Nome_da_Impressora' | translate }} <span class="text-red-500">*</span></label>
      <input
        id="nomeImpressoraDialog"
        type="text"
        pInputText
        [(ngModel)]="nome"
        placeholder="{{ 'Digite_o_Nome_da_Impressora' | translate }}"
        class="w-full" />
    </div>
    <div class="field">
      <label for="caminhoImpressoraDialog">{{ 'Caminho_da_Impressora' | translate }} <span class="text-red-500">*</span></label>
      <input
        id="caminhoImpressoraDialog"
        type="text"
        pInputText
        [(ngModel)]="caminho"
        placeholder="{{ 'Digite_o_Caminho_da_Impressora' | translate }}"
        class="w-full" />
    </div>
  </div>

  <!-- FOOTER -->
  <ng-template pTemplate="footer">
    <button pButton type="button" [label]="'cancelar' | translate"
      class="p-button-secondary"
      (click)="fechar()" [disabled]="salvando"></button>
    <button pButton type="button" [label]="(ehEdicao ? 'salvar' : 'adicionar') | translate"
      icon="pi pi-check"
      (click)="submit()" [disabled]="salvando"></button>
  </ng-template>
</p-dialog>
